import { render } from "./BaoCaoKetQuaKiemTraVSNuocSach.vue?vue&type=template&id=76fd5426&ts=true"
import script from "./BaoCaoKetQuaKiemTraVSNuocSach.vue?vue&type=script&lang=ts"
export * from "./BaoCaoKetQuaKiemTraVSNuocSach.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/CDC/BaoCao/CDC_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__